module.exports = __webpack_public_path__ + "assets/img/line1.020056d1.png";